/**
 * TimetablePage
 *
 * Manager interface for defining and managing the weekly farm schedule.
 * Part of US-C2-0B2: Timetable Management UI
 */

import { useState } from 'react'
import { PageLayout } from '@/components/layout'
import { Button } from '@/components/ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { TimetableGrid, SessionTypesManager, TaskMappingPanel, SchedulingRulesPanel } from '@/components/production/timetable'
import { Calendar, Tag, Link, Shield } from 'lucide-react'

export default function TimetablePage({ user, onLogout }) {
  const [showSessionTypesDialog, setShowSessionTypesDialog] = useState(false)

  return (
    <PageLayout
      title="Weekly Timetable"
      user={user}
      onLogout={onLogout}
      headerActions={
        <Button
          variant="outline"
          size="sm"
          onClick={() => setShowSessionTypesDialog(true)}
        >
          <Tag className="h-4 w-4 mr-2" />
          Manage Session Types
        </Button>
      }
    >
      <div className="space-y-6">
        <Tabs defaultValue="timetable" className="w-full">
          <TabsList className="grid w-full max-w-lg grid-cols-3">
            <TabsTrigger value="timetable" className="flex items-center gap-2">
              <Calendar className="h-4 w-4" />
              <span className="hidden sm:inline">Timetable</span>
            </TabsTrigger>
            <TabsTrigger value="mappings" className="flex items-center gap-2">
              <Link className="h-4 w-4" />
              <span className="hidden sm:inline">Task Mappings</span>
            </TabsTrigger>
            <TabsTrigger value="rules" className="flex items-center gap-2">
              <Shield className="h-4 w-4" />
              <span className="hidden sm:inline">Rules</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="timetable" className="mt-6">
            <TimetableGrid />
          </TabsContent>

          <TabsContent value="mappings" className="mt-6">
            <TaskMappingPanel />
          </TabsContent>

          <TabsContent value="rules" className="mt-6">
            <SchedulingRulesPanel />
          </TabsContent>
        </Tabs>
      </div>

      {/* Session Types Manager Dialog */}
      <SessionTypesManager
        open={showSessionTypesDialog}
        onOpenChange={setShowSessionTypesDialog}
      />
    </PageLayout>
  )
}
